<template>
    <div class="cart_resume__sub_total section">
        <div class="group">
            <div class="description">
                {{ copydeck.component_subtotal.txt_subtotal[lang] }}&nbsp;:
            </div>
            <div class="price">{{ roundTo(subtotal,2).toFixed(2) }}&nbsp;$</div>
        </div>

        <div class="group">
            <div class="description">
                {{ copydeck.component_subtotal.txt_pst[lang] }} ({{ prettyGstRate }}%)&nbsp;:
            </div>
            <div class="price">{{ roundTo(gst, 2).toFixed(2)}} $</div>
        </div>

        <div class="group">
            <div class="description">
                {{ copydeck.component_subtotal.txt_qst[lang] }}  ({{ prettyQstRate }}%)&nbsp;:
            </div>
            <div class="price">{{ roundTo(qst, 2).toFixed(2)}} $</div>
        </div>
    </div>
    <!-- div.cart_resume__sub_total -->

    <div class="cart_resume__total section">
        <div class="group">
            <div class="description">
                {{ copydeck.component_subtotal.txt_total[lang] }} :
            </div>
            <div class="price">{{ roundTo(total, 2).toFixed(2) }}&nbsp;$</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Subtotal"
}
</script>

<script setup>

import { ref, computed } from "vue";
import {useMainStore} from "../stores/main";
import {storeToRefs}  from "pinia";

let store = useMainStore();

let props = defineProps(["orders"])
let { copydeck, lang , gstRate, qstRate} = storeToRefs(store);
let { getSubtotal, getTaxableSubtotal, getGst, getQst, getOrderTotal, roundTo } = store;

let subtotal = computed ( () => getSubtotal(props.orders) );
let taxableSubtotal = computed ( () => getTaxableSubtotal(props.orders) );

//let pst = computed( () => (taxableSubtotal.value * 0.05).toFixed(2));
let gst = computed( () => (getGst(props.orders)));
//let qst = computed( () => (taxableSubtotal.value * 0.09975).toFixed(2));
let qst = computed( () => (getQst(props.orders)));

//let total = computed (() => (parseFloat(subtotal.value) + parseFloat(pst.value) + parseFloat(qst.value)).toFixed(2));
let total = computed (() => getOrderTotal(props.orders));

let prettyGstRate = parseFloat(gstRate.value * 100).toFixed(0);
let prettyQstRate = parseFloat(qstRate.value * 100).toFixed(3);

</script>
